import React, { Component } from 'react';
import styled from 'styled-components';
import GoogleMapReact from 'google-map-react';
import media from 'src/styles/media';
import { t } from 'src/utils/translate';

import Tabs from './elements/Tabs';
import TabsMobile from './elements/TabsMobile';
import MainMarker from './elements/MainMarker';
import Marker from './elements/Marker';

import mapStyles from './styles';
import { googleMapsAPIKey } from 'src/config/app.conf';

import mapLocations from 'src/data/map';

const categories = [
  t('neighbourhood.map.exercise'),
  t('neighbourhood.map.culture'),
  t('neighbourhood.map.eat'),
  t('neighbourhood.map.shops'),
  t('neighbourhood.map.schools'),
];

const colors = ['#377230', '#0071bf', '#b23292', '#f17428', '#967557'];

class Map extends Component {
  state = {
    category: null,
    activeMarker: null,
  };

  handleClickTab = val => {
    this.setState({ category: val, activeMarker: null });
  };

  handleClickMarker = val => {
    this.setState({
      activeMarker: val,
    });
  };

  render() {
    return (
      <Root>
        <TabsMobile
          tabs={categories}
          active={this.state.category}
          onClickTab={this.handleClickTab}
        />
        <Tabs
          tabs={categories}
          active={this.state.category}
          onClickTab={this.handleClickTab}
        />
        <MapContainer>
        <GoogleMapReact
          defaultCenter={{ lat: 49.2524133, lng: -123.2357115 }}
          defaultZoom={14}
          bootstrapURLKeys={{ key: googleMapsAPIKey }}
          options={{
            styles: mapStyles,
            disableDefaultUI: true,
          }}
        >
          <MainMarker lat={49.254694} lng={-123.230974} />
          {this.state.category !== null &&
            mapLocations[this.state.category].map((loc, index) => {
              return (
                <Marker
                  key={`${loc.title}${index}`}
                  onClick={() => this.handleClickMarker(index)}
                  active={index === this.state.activeMarker}
                  color={colors[this.state.category]}
                  lat={loc.loc[0]}
                  lng={loc.loc[1]}
                >
                  {loc.title}
                </Marker>
              );
            })}
        </GoogleMapReact>
        </MapContainer>
      </Root>
    );
  }
}

const Root = styled.div`
  width: 100%;
  position: relative;
`;

const MapContainer = styled.div`
  height: 715px;
  @media (max-width: ${media.md}) {
    height: 500px;
  }
`

export default Map;



// WEBPACK FOOTER //
// ./src/pages/Neighbourhood/elements/Map/Map.js